(() => {
  if (window.smdFavorites) return;

  const storageKey = 'smd:favorites:v1';
  const layer = document.querySelector('[data-smd-favorites-layer]');
  const dialog = layer?.querySelector('.smd-favorites-dialog');
  const list = layer?.querySelector('[data-smd-favorites-list]');
  const counts = [...document.querySelectorAll('[data-smd-favorites-count]')];
  const openers = [...document.querySelectorAll('[data-smd-favorites-open]')];
  if (layer) document.body.append(layer);
  let activeOpener = openers[0];
  let favorites = [];

  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) favorites = stored.filter(item => item && item.id && item.title && item.url);
  } catch {}

  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>';
  const save = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(favorites)); } catch {}
    paint();
  };
  const pulse = button => {
    const icon = button.querySelector('svg');
    if (!icon || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    icon.getAnimations().forEach(animation => animation.cancel());
    icon.animate([{transform:'scale(1)'},{transform:'scale(1.08)'},{transform:'scale(1)'}],{duration:220,easing:'ease-out'});
  };
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const paint = () => {
    counts.forEach(count => { count.textContent = String(favorites.length); });
    openers.forEach(opener => opener.setAttribute('aria-label', `Favoritos, ${favorites.length} ${favorites.length === 1 ? 'item' : 'itens'}`));
    document.querySelectorAll('[data-smd-favorite-item]').forEach(button => {
      const active = favorites.some(item => String(item.id) === button.dataset.productId);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remover' : 'Adicionar'} ${button.dataset.productTitle} ${active ? 'dos' : 'aos'} favoritos`);
      const label = button.querySelector('[data-smd-favorite-label]');
      if (label) label.textContent = active ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
    });
    if (!list || layer.hidden) return;
    list.replaceChildren();
    if (!favorites.length) {
      list.append(make('p', 'smd-favorites-empty', 'Você ainda não salvou produtos. Toque no coração de um produto para adicioná-lo.'));
      return;
    }
    favorites.forEach(item => {
      const row = make('article', 'smd-favorite-row');
      const link = make('a', 'smd-favorite-product');
      link.href = item.url;
      if (item.image) {
        const image = make('img', 'smd-favorite-image');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        link.append(image);
      }
      const copy = make('span', 'smd-favorite-copy');
      copy.append(make('strong', '', item.title));
      if (item.price) copy.append(make('small', '', item.price));
      link.append(copy);
      const remove = make('button', 'smd-pulse-heart smd-favorite-remove');
      remove.type = 'button';
      remove.dataset.smdRemoveFavorite = String(item.id);
      remove.setAttribute('aria-pressed', 'true');
      remove.setAttribute('aria-label', `Remover ${item.title} dos favoritos`);
      remove.insertAdjacentHTML('afterbegin', heart);
      row.append(link, remove);
      list.append(row);
    });
  };
  const place = () => {
    if (!dialog || layer.hidden || !activeOpener) return;
    const trigger = activeOpener.getBoundingClientRect();
    const panel = dialog.getBoundingClientRect();
    let top = trigger.bottom + 10;
    if (top + panel.height > innerHeight - 12) top = Math.max(12, trigger.top - panel.height - 10);
    const left = Math.max(12, Math.min(trigger.right - panel.width, innerWidth - panel.width - 12));
    dialog.style.top = `${top}px`;
    dialog.style.left = `${left}px`;
  };
  const close = (restoreFocus = true) => {
    if (!layer || layer.hidden) return;
    layer.hidden = true;
    openers.forEach(opener => opener.setAttribute('aria-expanded', 'false'));
    if (restoreFocus) activeOpener?.focus();
  };
  const open = trigger => {
    if (!layer) return;
    window.smdMobileMenu?.close(true);
    activeOpener = trigger || openers[0];
    layer.hidden = false;
    paint();
    openers.forEach(opener => opener.setAttribute('aria-expanded', String(opener === activeOpener)));
    requestAnimationFrame(place);
    layer.querySelector('[data-smd-favorites-close]')?.focus();
  };

  document.addEventListener('click', event => {
    const openButton = event.target.closest('[data-smd-favorites-open]');
    if (openButton) {
      event.preventDefault();
      if (layer && !layer.hidden && activeOpener === openButton) close();
      else open(openButton);
      return;
    }
    if (event.target.closest('[data-smd-favorites-close]')) { close(); return; }
    if (layer && !layer.hidden && !dialog?.contains(event.target) && !openers.some(opener => opener.contains(event.target))) close(false);

    const remove = event.target.closest('[data-smd-remove-favorite]');
    if (remove) {
      event.preventDefault();
      favorites = favorites.filter(item => String(item.id) !== remove.dataset.smdRemoveFavorite);
      pulse(remove);
      save();
      return;
    }

    const toggle = event.target.closest('[data-smd-favorite-item]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    const id = toggle.dataset.productId;
    const existing = favorites.some(item => String(item.id) === id);
    favorites = existing
      ? favorites.filter(item => String(item.id) !== id)
      : [...favorites, { id, handle: toggle.dataset.productHandle, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl, image: toggle.dataset.productImage, price: toggle.dataset.productPrice }];
    pulse(toggle);
    save();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && layer && !layer.hidden) close();
  });
  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true, capture: true });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    try { favorites = JSON.parse(event.newValue || '[]'); } catch { favorites = []; }
    paint();
  });
  window.smdFavorites = { open, close, refresh: paint };
  openers.forEach(opener => opener.setAttribute('aria-expanded', 'false'));
  paint();
})();
